var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerraform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.826767 0 0 .826767 8.416322 51.138164)",
    className: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1 15.557v-24.43l-21.16-12.22v24.43zm0-27.1l-21.16-12.22v-24.44l21.16 12.22z",
    fill: "#5c4ee5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6-23.773v-24.44l-21.17 12.22v24.44z",
    fill: "#4040b2"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5c4ee5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.62-25.193v-24.44l-21.16-12.22v24.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.64-.483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.94-21.093"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerraform);
export default __webpack_public_path__ + "static/media/terraform.756be59b.svg";
export { ForwardRef as ReactComponent };